export default function paymentRejections(msg: any) {
  if (msg?.toLowerCase() === 'gateway rejected') {
    return 'Gateway rejected, get in touch with Bidmii support for more information.';
  } else if (msg?.toLowerCase() === 'processor declined') {
    return 'Processor declined, contact your financial institution for more information.';
  } else {
    return msg;
  }
}
